module.exports = __webpack_public_path__ + "img/07.dced0b31.jpg";